import gql from 'graphql-tag';

export const getReader = gql`
  query ($deviceId: Int) {
    getReader(deviceId: $deviceId) {
      deviceId
      application {
        applicationId
      }
      name
      model {
        modelId
        name
        remark
      }
      serial
      mac
      region
      longitude
      latitude
      distance
      remark
      optional
      date
      method
      forward
      active
      mCoefficient1
		  mCoefficient2
		  mCoefficient3
      battery
      live
      humidity
      temperature
      tags
      compositionData
      unicastAddr
      meshStatus
    }
  }
`
